var _style, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEuroIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 666.7 666.7",
    style: {
      enableBackground: "new 0 0 666.7 666.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#071B8C;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FEFF01;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 333.3,
    cy: 333.3,
    r: 333.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M287.2,250c14.6-26.1,39.6-50,71.1-50c17.8,0,35.6,7.7,51.4,23.5c13,13,34.1,13,47.1,0c13-13,13-34.1,0-47.1 c-26-26.1-60.1-43.1-98.6-43.1c-47.4,0-87.7,25.7-115.1,62.1c-12,16-21.8,34.4-29.1,54.5H200c-18.4,0-33.3,14.9-33.3,33.3 c0,15.3,10.3,28.1,24.3,32.1c3.1,0.9,6.3,1.2,9.6,1.2c-0.7,11-0.7,22.3,0,33.3c-3.2,0-6.5,0.4-9.6,1.2c-14,3.9-24.3,16.8-24.3,32.1 c0,18.4,14.9,33.3,33.3,33.3h14.2c7.2,20.1,17,38.5,29.1,54.5c27.4,36.5,67.7,62.1,115.1,62.1c38.5,0,72.6-17.1,98.6-43.1 c13-13,13-34.1,0-47.1c-13-13-34.1-13-47.1,0c-15.8,15.8-33.6,23.6-51.4,23.6c-31.6,0-56.5-23.9-71.1-50h46.1 c18.4,0,33.3-14.9,33.3-33.3c0-18.4-14.9-33.3-33.3-33.3h-65.9c-1-10.9-1-22.5,0-33.3h99.3c18.4,0,33.3-14.9,33.3-33.3 c0-18.4-14.9-33.3-33.3-33.3H287.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuroIcon);
export default __webpack_public_path__ + "static/media/euro_icon.5b3c7815fd8f6e1e6fa7c34b2150c939.svg";
export { ForwardRef as ReactComponent };